import { IsOptional, IsUUID } from 'class-validator';

export class CreateEventWithEventTypeGroupDto {
  @IsUUID()
  @IsOptional()
  eventTypeGroup?: string;
}
